export { default as Img200 } from './processed/200/Sorcerers-Apprentice-The.jpg';
export { default as Img400 } from './processed/400/Sorcerers-Apprentice-The.jpg';
export { default as Imgthumb } from './processed/thumb/Sorcerers-Apprentice-The.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Sorcerers-Apprentice-The.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Sorcerers-Apprentice-The.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      6,
      163,
      178
    ],
    "_population": 487,
    "_hsl": [
      0.5145348837209303,
      0.9347826086956521,
      0.3607843137254902
    ]
  },
  "LightVibrant": {
    "_rgb": [
      182,
      221,
      226
    ],
    "_population": 224,
    "_hsl": [
      0.5189393939393939,
      0.4313725490196077,
      0.8
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      10,
      114,
      84
    ],
    "_population": 2603,
    "_hsl": [
      0.4519230769230769,
      0.8387096774193548,
      0.2431372549019608
    ]
  },
  "Muted": {
    "_rgb": [
      93,
      163,
      139
    ],
    "_population": 691,
    "_hsl": [
      0.44285714285714284,
      0.2755905511811023,
      0.5019607843137255
    ]
  },
  "LightMuted": {
    "_rgb": [
      169,
      205,
      201
    ],
    "_population": 99,
    "_hsl": [
      0.4814814814814814,
      0.2647058823529413,
      0.7333333333333334
    ]
  },
  "DarkMuted": {
    "_rgb": [
      47,
      87,
      67
    ],
    "_population": 346,
    "_hsl": [
      0.4166666666666667,
      0.29850746268656714,
      0.2627450980392157
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Sorcerers-Apprentice-The.js